import React from "react";
import PropTypes from "prop-types";

export const SubSection = ({ label = "", headerVariant = "small", separatorVariant = "normal", children }) => {
    return (
        <div className={`subsection ${separatorVariant === "none" ? "" : `${separatorVariant === "thick" ? "separator--thick" : "separator"}`}`}>
            <div className="row">
                <div className="column">
                    {label && <div className="subsection__header ">{headerVariant === "small" ? <h3>{label}</h3> : <h2>{label}</h2>}</div>}
                    {children}
                </div>
            </div>
        </div>
    );
};

export const SubSectionInfo = ({ label, bold = false, children }) => {
    return (
        <div>
            <div className={`${bold ? "bold" : ""}`}>{label}</div>
            {children}
        </div>
    );
};

SubSection.propTypes = {
    label: PropTypes.string,
    separatorVariant: PropTypes.oneOf(["thick", "normal", "none"]),
    headerVariant: PropTypes.oneOf(["big", "small"]),
};
